<div class="m-section" [ngClass]="'m-section--' + variant" [class.m-section--dense]="dense">
  <div class="m-section-header">
    <div class="m-section-icon"><i class="bi" [ngClass]="icon"></i></div>
    <div class="m-section-header-text">
      <h6 class="m-section-title mb-0">{{ title }}</h6>
      <small *ngIf="subtitle" class="m-section-subtitle">{{ subtitle }}</small>
    </div>
    <div class="m-section-actions"><ng-content select="[sectionActions]"></ng-content></div>
  </div>
  <div class="m-section-body"><ng-content></ng-content></div>
</div>
